import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero2/Hero2";
import HeroImage from "../assets/OurServicesHero.png";
import OurServicesSection1 from "../components/OurServices/OurServices1/ourservices1";
import OurServicesSection2 from "../components/OurServices/OurServices2/ourservices2";
import OurServicesSection3 from "../components/OurServices/OurServices3/ourservices3";
import SEO from "../components/SEO";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="OurServices" />
      <Navbar />
      <Hero
        cName="contact-us-hero2"
        heroImg={HeroImage}
        title={t("pages.ourServices.title")}
        text={t("pages.ourServices.text")}
      />
      <OurServicesSection1 />
      <OurServicesSection2 />

      <OurServicesSection3 />

      <Footer />
    </>
  );
};

export default Services;
